$(function() {

$(".beer40-slider").slick(
    {
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
        {
        breakpoint: 767,
            settings: {
                dots: false,
                arrows: true
            }
        },
    ]
    });

$(".collection-slider").slick({
    slidesToShow: 1,
    arrows: false,
    mobileFirst: true,
    centerMode: true,
    centerPadding: '50px',
    responsive: [
    {
        breakpoint: 576,
        settings: {
        slidesToShow: 3,
        centerPadding: false,
        }
    }
  ]
});

});